import React from 'react';
import { VMSLogo } from '../../icons/VMSLogo';
import { LoginForm } from './LoginForm';
import { LoginCover } from './LoginCover';
import { Copyright, Title } from '../../components/Text';
import { FixedFlexBox } from '../../components/Cover';
import { Flex } from '../../components/Flex';

const Login = ({ error, onLogin }) => {

    return(
        <>
            <LoginCover />
            <FixedFlexBox
                height="100%"
                width="360px"
                top={0}
                left={0}
                padding="32px"
                background="#FFFFFF"
                box-shadow="4px 0px 8px rgba(6, 24, 52, 0.3)"
            >
                <div>
                    <div style={{ marginBottom: "32px" }}>
                        <VMSLogo />
                    </div>
                    <Flex direction="column" margin={{ bottom: "16px" }}>
                        <Title h1>Log in</Title>
                        <Title h1>to your account</Title>
                    </Flex>
                    {error && <div style={{ color: "#FF5A5A" }}>{error}</div>}
                    <LoginForm onLogin={onLogin} />
                </div>
                <Flex direction="column">
                    <Flex direction="column" margin={{ bottom: "12px"}}>
                        <Copyright>&copy; Copyright 2014&ndash;{new Date().getFullYear()}, VMS Software, Inc.</Copyright>
                        <Copyright>All rights reserved.</Copyright>
                    </Flex>
                    <Flex direction="column">
                        <Copyright>VMS SOFTWARE INC. 800 District Ave Suite 530,</Copyright>
                        <Copyright>Burlington, MA 01803, USA</Copyright>
                    </Flex>
                </Flex>
            </FixedFlexBox>
        </>
    );
};

export { Login };